import { AiOutlinePlus } from 'react-icons/ai';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../../assets/svg/sort';
import { Button } from '../../../../../../components/button/button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import s from './branches-controls.module.css';

export const BranchesControls = () => {
  const { t } = useLang();
  const { handleOpenModal: handleOpenCreateModal } = useModalParams('createBranch');

  return (
    <div className={s.feature}>
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По названию'),
            value: 'name',
            filter: 'input',
          },
          {
            label: t('По кол-ву сотрудников'),
            value: 'staff_count',
            filter: 'range',
          },
          {
            label: t('По адресу'),
            value: 'address',
            filter: 'input',
          },
          {
            label: t('По телефону'),
            value: 'phone',
            filter: 'input',
          },
          {
            label: t('По дате создания'),
            value: 'created_at',
            filter: 'datetime-range',
          },
        ]}
      />

      <Button className={s.button} onClick={() => handleOpenCreateModal()} size="lg">
        <AiOutlinePlus />
        <span className="hide__M hide__S">{t('Добавить филиал')}</span>
      </Button>
    </div>
  );
};
